import React, { Component, Fragment } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Input,
  Modal,
  FileUpload,
  ODataTable,
  Progress,
} from 'framework-ui-components';
import { creaDaXmlAnnoCorrente } from 'apis/setteTrentaApi';
import { TipoImportazione, StatoDichiarazioneDaImportare } from 'enums';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import RigaImportazione from './RigaImportazione';
import InputRicerca from '../../../components/InputRicerca';

const _tipoImportazione = {
  NonSelezionato: 0,
  Corrente: 1,
  Precedente: 2,
};

function MessaggioSelezionaDeseleziona(stato) {
  switch (stato) {
    case false:
      return 'Deseleziona tutte';
      break;
    case true:
      return 'Seleziona tutte';
      break;
  }
}

function calcolaUploadSpeed(uploadedBytes, timeStarted) {
  const timeElapsed = new Date() - timeStarted; // Assuming that timeStarted is a Date Object
  const uploadSpeed = uploadedBytes / (timeElapsed / 1000); // Upload speed in second
  // console.log(uploadSpeed, timeStarted, timeElapsed / 1000);
  return uploadSpeed;
}

function sommaUploadSpeed(sumAverageUpload, byteLoaded, inizioUpload) {
  return sumAverageUpload + calcolaUploadSpeed(byteLoaded, inizioUpload);
}

function calcolaAverageUploadSpeed(
  sumAverageUpload,
  byteLoaded,
  inizioUpload,
  contaFeedbackUpload,
) {
  return (
    sommaUploadSpeed(sumAverageUpload, byteLoaded, inizioUpload)
    / contaFeedbackUpload
    + 1
  );
}

function calcolaTempoTotaleGeneraLista(averageUpload, bytesTotaliFornitura) {
  // calcolo a spanne il numero di dichiarazioni in base ai bytes della fornitura
  const numeroDichiarazioni = parseInt(bytesTotaliFornitura / 14000).toFixed(0);
  // console.log(averageUpload, numeroDichiarazioni);
  const scartoSePocheDichiarazioni = numeroDichiarazioni < 30 ? 0.15 : 0;
  // in base alla velocità media dell'upload mi calcolo a spanne quanto tempo può impiegare l'elaborazione della lista
  if (averageUpload < 40000) {
    return parseInt(numeroDichiarazioni * (0.36 + scartoSePocheDichiarazioni)).toFixed(1);
  }
  if (averageUpload < 66000) {
    return parseInt(numeroDichiarazioni * (0.30 + scartoSePocheDichiarazioni)).toFixed(1);
  }
  if (averageUpload < 100000) {
    return parseInt(numeroDichiarazioni * (0.13 + scartoSePocheDichiarazioni)).toFixed(1);
  }
  if (averageUpload < 400000) {
    return parseInt(numeroDichiarazioni * (0.08 + scartoSePocheDichiarazioni)).toFixed(1);
  }
  return parseInt(numeroDichiarazioni * (0.025 + scartoSePocheDichiarazioni)).toFixed(1);
}

const FORM_INITIAL_STATE = {
  TipoImportazione: _tipoImportazione.NonSelezionato,
  windowMessage: '',
  caricandoPercentualeGeneraLista: false,
  listaDichiarazioni: [],
  fileCaricati: [],
  selezionaFile: true,
  messaggioSeleziona: true,
  currentCountGeneraLista: 30,
  contaFeedbackUpload: 0,
  sumAverageUpload: 0,
  averageUpload: 0,
};

class ModaleImportazione extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...FORM_INITIAL_STATE,
      bloccaInserimento: true,
      caricandoPercentualeGeneraLista: false,
      listaDichiarazioni: [],
      fileCaricati: [],
      selezionaFile: true,
      messaggioSeleziona: true,
      searchTerm: null,
      currentCountGeneraLista: 30,
      contaFeedbackUpload: 0,
      sumAverageUpload: 0,
      uploadProgress: {},
      averageUpload: 0,
      totaleBytes: 0,
      totaleFiles: 0,
      InizioUpload: null,
    };

    this.initializeComponent();
  }

  componentDidMount() {
    if (this.props.tipoImportazione == _tipoImportazione.Corrente) {
      this.setState({ TipoImportazione: TipoImportazione.Corrente });
    }
    if (this.props.showModal) {
      setTimeout(
        () => this.fileUpload && findDOMNode(this.fileUpload).click(),
        100,
      );
    }
    const intervalId = setInterval(this.timerGeneraLista, 1000);
    // store intervalId in the state so it can be accessed later:
    this.setState({ intervalIdGeneraLista: intervalId });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.tipoImportazione != nextProps.tipoImportazione
      && nextProps.tipoImportazione == _tipoImportazione.Corrente
    ) {
      this.setState({ TipoImportazione: TipoImportazione.Corrente });
    }
    if (nextProps.showModal != this.props.showModal && nextProps.showModal) {
      setTimeout(
        () => this.fileUpload && findDOMNode(this.fileUpload).click(),
        100,
      );
    }
  }

  initializeComponent() {
    this.annulla = this.annulla.bind(this);
    this.crea = this.crea.bind(this);
    this.updateForm = this.updateForm.bind(this);
  }

  annulla() {
    this.setState(
      FORM_INITIAL_STATE,
      () => this.props.onAnnulla && this.props.onAnnulla(),
    );
  }

  crea() {
    const { listaDichiarazioni, fileCaricati } = this.state;
    const { ufficioSelezionato, annoSelezionato, onAnnulla } = this.props;

    if (!listaDichiarazioni.some((z) => z.DaImportare)) {
      SnackbarManager.notifyError('Nessun elemento selezionato');
    } else {
      const dichiarazioniPerFile = listaDichiarazioni.filter((x) => x.DaImportare).reduce((memo, x) => {
        const { res, file } = fileCaricati.find((y) => y.res.ListaDichiarazioni.some((z) => z.CodiceFiscaleDichiarante === x.CodiceFiscaleDichiarante));
        const context = memo.find((y) => y.file === file);

        if (context) {
          context.lista.push(x);
        } else {
          memo.push({ res, file, lista: [x] });
        }

        return memo;
      }, []);

      const promises = dichiarazioniPerFile.map(({ res, file, lista }) => creaDaXmlAnnoCorrente(res.PathFornituraXmlAnnoCorrenteDaImportare, lista, ufficioSelezionato, annoSelezionato, file.name));

      return Promise.all(promises).then((results) => {
        this.setState({
          listaDichiarazioni: [],
          fileCaricati: [],
          selezionaFile: true,
          totaleFiles: 0,
          totaleBytes: 0,
          averageUpload: 0,
          messaggioSeleziona: true,
          caricandoPercentualeGeneraLista: false,
        });

        results.forEach((x, i) => {
          if (!x.Success) {
            SnackbarManager.notifyError(`Si è verificato un errore durante l'importazione dell'XML "${dichiarazioniPerFile[i].file.name}" (${x.DetectedProblems[0]})`);
          }
        });

        if (!results.some((x) => !x.Success)) {
          SnackbarManager.notifySuccess('Importazione XML avviata con successo!');
        }

        onAnnulla && onAnnulla();
      });
    }
  }

  updateForm(data) {
    this.setState(data);
  }

  aggiungiLista = (res, file) => {
    if (!res) {
      SnackbarManager.notifyError(`Si è verificato un errore durante l'importazione dell'XML "${file.name}"`);
    } else if (!res.Success) {
      SnackbarManager.notifyError(`Si è verificato un errore durante l'importazione dell'XML "${file.name}" (${res.DetectedProblems[0]})`);
    }

    this.setState(({
      totaleFiles, fileCaricati, listaDichiarazioni, intervalIdGeneraLista,
    }) => {
      const fileRimasti = totaleFiles - 1;
      const dichiarazioni = [...listaDichiarazioni, ...res.ListaDichiarazioni];
      const codiciFiscali = dichiarazioni.map((x) => [x.CodiceFiscaleDichiarante, x.CodiceFiscaleConiuge]).flat();
      const codiciFiscaliDoppi = codiciFiscali.filter((x) => x && codiciFiscali.filter((y) => y === x).length > 1);
      const codiceFiscaleDoppio = (item) => codiciFiscaliDoppi.includes(item.CodiceFiscaleDichiarante) || codiciFiscaliDoppi.includes(item.CodiceFiscaleConiuge);
      const lista = dichiarazioni.map((x) => ({
        ...x,
        CodiceFiscaleDoppio: codiceFiscaleDoppio(x),
        DaImportare: !codiceFiscaleDoppio(x) && x.DaImportare,
        StatoDichiarazioneDaImportare: codiceFiscaleDoppio(x) ? StatoDichiarazioneDaImportare.NonImportabile : x.StatoDichiarazioneDaImportare,
      }));

      if (fileRimasti === 0) {
        clearInterval(intervalIdGeneraLista);
      }

      return {
        totaleFiles: fileRimasti,
        caricandoPercentualeGeneraLista: fileRimasti > 0,
        fileCaricati: [...fileCaricati, { res, file }],
        selezionaFile: fileRimasti > 0,
        messaggioSeleziona: lista.some((x) => !x.DaImportare && x.StatoDichiarazioneDaImportare !== StatoDichiarazioneDaImportare.NonImportabile),
        listaDichiarazioni: lista,
      };
    });
  };

  impostaDaImportare = (cf) => {
    const dichiarazioni = this.state.listaDichiarazioni;
    dichiarazioni.forEach((x) => {
      if (x.CodiceFiscaleDichiarante == cf) {
        x.DaImportare = !x.DaImportare;
      }
    });

    this.setState({ listaDichiarazioni: dichiarazioni });
  };

  selezionaTutte(lista) {
    const daImportare = this.state.messaggioSeleziona;
    lista
      .filter((z) => z.StatoDichiarazioneDaImportare != 2)
      .map((x) => {
        x.DaImportare = daImportare;
        return x;
      });
    this.setState({
      listaDichiarazioni: lista,
      messaggioSeleziona: !daImportare,
    });
  }

  paginaRisultati = (top, skip, sortProperty, sortOrder, filters) => {
    let dichDaPaginare = this.state.listaDichiarazioni;
    if (this.state.searchTerm) {
      dichDaPaginare = dichDaPaginare.filter(
        (x) => (x.DescrizioneDichiarante
          && x.DescrizioneDichiarante.toLowerCase().indexOf(
            this.state.searchTerm.toLowerCase(),
          ) != -1)
          || (x.CodiceFiscaleDichiarante
            && x.CodiceFiscaleDichiarante.toLowerCase().indexOf(
              this.state.searchTerm.toLowerCase(),
            ) != -1)
          || (x.DescrizioneConiuge
            && x.DescrizioneConiuge.toLowerCase().indexOf(
              this.state.searchTerm.toLowerCase(),
            ) != -1)
          || (x.CodiceFiscaleConiuge
            && x.CodiceFiscaleConiuge.toLowerCase().indexOf(
              this.state.searchTerm.toLowerCase(),
            ) != -1)
          || (x.DescrizioneSostituto
            && x.DescrizioneSostituto.toLowerCase().indexOf(
              this.state.searchTerm.toLowerCase(),
            ) != -1),
      );
    }

    if (sortProperty) {
      dichDaPaginare = dichDaPaginare.sort((a, b) => {
        const x = a[sortProperty] || '';
        const y = b[sortProperty] || '';
        if (x < y) {
          return sortOrder ? -1 : 1;
        }
        if (x > y) {
          return sortOrder ? 1 : -1;
        }
        return 0;
      });
    }
    const paginazione = dichDaPaginare.slice(skip, skip + top);
    return {
      Items: paginazione,
      Count: dichDaPaginare.length,
    };
  };

  filtraListaRisultati = (searchTerm) => {
    this.setState(
      { searchTerm: searchTerm.trim() },
      () => this.tabellaImport && this.tabellaImport.loadPage(),
    );
  };

  // in base ai byte caricati e ai byte totali del file calcolo quanto manca
  tempoRimanente = (uploadedBytes, totalBytes, timeStarted) => {
    const uploadSpeed = calcolaUploadSpeed(uploadedBytes, timeStarted);

    const tempTempoRimanente = ((totalBytes - uploadedBytes) / uploadSpeed) * 1000;
    const tempo = new Date(tempTempoRimanente).toISOString().substr(11, 8);

    // const tempTempoRimanenteAverage = ((totalBytes - uploadedBytes) / this.state.averageUpload) * 1000;
    // const tempoAverage = new Date(tempTempoRimanenteAverage).toISOString().substr(11, 8);

    // debugger;
    // console.log("temporimanente: ", tempTempoRimanente, tempo, tempoAverage);
    return tempo;
  };

  PercentualeElaborazioneLista = (tempoTotaleGenerazioneLista, tempoRimanente) => {
    const tempoTrascorso = tempoTotaleGenerazioneLista - tempoRimanente;
    if (tempoTrascorso < 0) {
      return 100;
    }
    return parseInt(((tempoTrascorso * 100) / tempoTotaleGenerazioneLista).toFixed(1));
  }

  timerGeneraLista = () => {
    const {
      caricandoPercentualeGeneraLista,
      currentCountGeneraLista,
      intervalIdGeneraLista,
      averageUpload,
      totaleBytes,
    } = this.state;

    const percentualeCaricamento = this.calcolaPercentualeCaricamento();
    let tempcaricandoPercentualeGeneraLista = caricandoPercentualeGeneraLista;
    let tempcurrentCountGeneraLista = currentCountGeneraLista;

    if (caricandoPercentualeGeneraLista === false && percentualeCaricamento === 100) {
      tempcaricandoPercentualeGeneraLista = true;
      tempcurrentCountGeneraLista = calcolaTempoTotaleGeneraLista(
        averageUpload,
        totaleBytes,
      );
    }

    const newCount = percentualeCaricamento >= 100 ? tempcurrentCountGeneraLista - 1 : tempcurrentCountGeneraLista;

    if (newCount >= 0) {
      this.setState({
        currentCountGeneraLista: newCount,
        caricandoPercentualeGeneraLista: tempcaricandoPercentualeGeneraLista,
      });
    } else {
      clearInterval(intervalIdGeneraLista);
    }
  };

  calcolaBytesCaricati() {
    const { uploadProgress } = this.state;
    return Object.values(uploadProgress).reduce((memo, x) => memo + x.loaded, 0);
  }

  calcolaPercentualeCaricamento() {
    const { totaleBytes } = this.state;
    return parseInt((this.calcolaBytesCaricati() / totaleBytes * 100).toFixed(1));
  }

  render() {
    const {
      showModal,
      isLoading,
      tipoImportazione,
    } = this.props;
    const {
      totaleBytes,
      selezionaFile,
      messaggioSeleziona,
      InizioUpload,
      currentCountGeneraLista,
      averageUpload,
    } = this.state;

    const percentualeCaricamento = this.calcolaPercentualeCaricamento();
    const bytesCaricati = this.calcolaBytesCaricati();
    const mostraGeneraLista = percentualeCaricamento >= 100;

    return (
      <Modal
        show={showModal}
        onClose={this.annulla}
        loading={isLoading}
        className="modaleImportazioneXml"
      >
        <Modal.Header>
          Importazione da XML {TipoImportazione.stringify(tipoImportazione)}
        </Modal.Header>
        <Modal.Body>
          <div className="modaleImportazioneXml__body">
            {selezionaFile ? (
              <Fragment>
                <FileUpload
                  url={`/SetteTrenta/ListaImportazioneXml?studio=${this.props.ufficioSelezionato}&anno=${this.props.annoSelezionato}`}
                  multiple
                  accept={['.xml']}
                  onFileUploaded={this.aggiungiLista}
                  onProgress={(evt, progress, file) => {
                    this.setState(({
                      sumAverageUpload, contaFeedbackUpload, uploadProgress,
                    }) => ({
                      uploadProgress: { ...uploadProgress, [file.name]: { loaded: evt.loaded, total: evt.total } },
                      sumAverageUpload: sommaUploadSpeed(
                        sumAverageUpload,
                        bytesCaricati,
                        InizioUpload,
                      ),
                      contaFeedbackUpload: contaFeedbackUpload + 1,
                      averageUpload: calcolaAverageUploadSpeed(
                        sumAverageUpload,
                        bytesCaricati,
                        InizioUpload,
                        contaFeedbackUpload,
                      ),
                      currentCountGeneraLista: null,
                    }));
                  }}
                  onChange={(evt) => {
                    this.setState({
                      InizioUpload: Date.now(),
                      caricandoPercentualeGeneraLista: false,
                      totaleFiles: evt.target.files.length,
                      totaleBytes: Array.from(evt.target.files).reduce((memo, x) => x.size + memo, 0),
                    });
                  }}
                >
                  <strong>Scegli la fornitura da importare&nbsp;&nbsp;</strong>
                  <Button ref={(r) => (this.fileUpload = r)} disabled={InizioUpload != null}>
                    Seleziona file
                  </Button>
                </FileUpload>
                <br />
                &nbsp;
                {percentualeCaricamento && percentualeCaricamento !== 0 ? (
                  <Fragment>
                    <br />
                    &nbsp;
                    <br />
                    <strong>Caricamento del file</strong>
                    <Progress
                      percentage={percentualeCaricamento}
                      text={
                        percentualeCaricamento < 100
                          ? `Caricamento file: ${percentualeCaricamento}% - Tempo rimanente: ${this.tempoRimanente(bytesCaricati, totaleBytes, InizioUpload)}`
                          : 'Caricamento file: completato'
                      }
                    />
                  </Fragment>
                ) : (
                  <div />
                )}
                {mostraGeneraLista == true ? (
                  <Fragment>
                    <br />
                    &nbsp;
                    <br />
                    <strong>Elaborazione fornitura telematica</strong>
                    <Progress
                      percentage={this.PercentualeElaborazioneLista(calcolaTempoTotaleGeneraLista(averageUpload, totaleBytes), currentCountGeneraLista)}
                      text={`Elaborazione fornitura: ${this.PercentualeElaborazioneLista(calcolaTempoTotaleGeneraLista(averageUpload, totaleBytes), currentCountGeneraLista)}% - Tempo rimanente: ${new Date(currentCountGeneraLista * 1000).toISOString().substr(11, 8)}`}
                    />
                    <br />
                    &nbsp;
                    <div>
                      Al termine dell'elaborazione sarà possibile scegliere le
                      dichiarazioni da importare
                    </div>
                  </Fragment>
                ) : (
                  <div>
                    <br />
                    &nbsp;
                    <br /> &nbsp;
                    <br /> &nbsp;
                  </div>
                )}
              </Fragment>
            ) : (
              <Grid fluid>
                <Grid.Row>
                  <Grid.Col md="5">
                    <InputRicerca onClickCerca={this.filtraListaRisultati} />
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col md="4">
                    {!selezionaFile && (
                      <label className="mt-8">
                        {
                          this.state.listaDichiarazioni.filter(
                            (x) => x.DaImportare === true,
                          ).length
                        }{' '}
                        dichiarazioni selezionate su{' '}
                        {this.state.listaDichiarazioni.length}
                      </label>
                    )}
                  </Grid.Col>
                  <Grid.Col md="8" className="text--right">
                    {!selezionaFile && (
                      <Button
                        flat
                        selected
                        onClick={() => this.selezionaTutte(this.state.listaDichiarazioni)}
                      >
                        {MessaggioSelezionaDeseleziona(messaggioSeleziona)}
                      </Button>
                    )}
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col md="12">
                    <ODataTable
                      ref={(r) => (this.tabellaImport = r)}
                      dataSource={this.paginaRisultati}
                      pageSize={10}
                      sortProperty="CodiceFiscaleDichiarante"
                      availablePageSizes={[5, 10, 20]}
                      additionalRowData={{
                        impostaDaImportare: this.impostaDaImportare,
                      }}
                      row={RigaImportazione}
                    >
                      <ODataTable.Column />
                      <ODataTable.Column propertyName="CodiceUfficio">
                        Ufficio
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="DescrizioneDichiarante">
                        Dichiarante
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="CodiceFiscaleDichiarante">
                        CF Dichiarante
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="Tipo">
                        Tipo
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="StatoDichiarazioneDaImportare">
                        Stato
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="DescrizioneConiuge">
                        Coniuge
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="CodiceFiscaleConiuge">
                        CF Coniuge
                      </ODataTable.Column>
                      <ODataTable.Column propertyName="DescrizioneSostituto">
                        Sostituto
                      </ODataTable.Column>
                    </ODataTable>
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button flat onClick={this.annulla}>
            Annulla
          </Button>
          <Button flat primary disabled={selezionaFile} onClick={this.crea}>
            Procedi
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleImportazione.TipoImportazione = _tipoImportazione;

ModaleImportazione.propTypes = {
  datiIniziali: PropTypes.object,
  isLoading: PropTypes.bool,
  messaggioErrore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onAnnulla: PropTypes.func.isRequired,
  onCreaNuova: PropTypes.func,
  onRipristinaEliminata: PropTypes.func,
  showModal: PropTypes.bool.isRequired,
  tipoImportazione: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  ufficioSelezionato: PropTypes.string,
  annoSelezionato: PropTypes.number,
};

ModaleImportazione.defaultProps = {
  tipoImportazione: _tipoImportazione.NonSelezionato,
};

export default ModaleImportazione;
